<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <path fill="currentColor" d="M9.617 8.054 4.97 12.7l.707.708 5.354-5.354L5.677 2.7l-.707.708z"/>
</svg>